export function loadOfficeJs(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof Office !== "undefined") {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js";
    script.onload = () => {
      if (typeof Office === "undefined") {
        reject(new Error("Office.js failed to load"));
        return;
      }
      Office.onReady((info) => resolve());
    };
    script.onerror = () => reject(new Error("Failed to load Office.js"));
    document.head.appendChild(script);
  });
}
